import type { MenuListItem } from '@/constants/menuLists';
import type { Brand, BrandVisibility } from './types';

export function filterMenuByBrand(
  items: readonly MenuListItem[],
  brand: Brand,
): MenuListItem[] {
  return items
    .filter((item) => {
      const visibility: BrandVisibility = item.brand ?? 'both';
      return visibility === 'both' || visibility === brand;
    })
    .map((item) => {
      if (item.subList) {
        return { ...item, subList: filterMenuByBrand(item.subList, brand) };
      }
      return item;
    });
}
